import { render, staticRenderFns } from "./UserWaitingList.vue?vue&type=template&id=8541b136"
import script from "./UserWaitingList.vue?vue&type=script&lang=js"
export * from "./UserWaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports